import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { useUpdateFollowing } from '@hooks/followers/useUpdateFollowing';

import React, { useCallback } from 'react';

export interface BulkFollowCheckboxProps {
	onChange: (checked?: boolean) => void;
	sonarObjectIds?: number[];
	value?: boolean;
}

export const BulkFollwCheckbox: React.FC<BulkFollowCheckboxProps> = ({ onChange, sonarObjectIds, value }) => {
	const { followed, unfollowed } = useUpdateFollowing(sonarObjectIds);
	const allFollowed = unfollowed.length === 0;
	const allUnfollowed = followed.length === 0;
	const checked = value ?? allFollowed;
	const indeterminate = value === undefined && (!sonarObjectIds || (!allFollowed && !allUnfollowed));
	const stateText = checked ? COPY_SPECIFIC.FOLLOWING : `${COPY_SPECIFIC.NOT} ${COPY_SPECIFIC.FOLLOWING}`;

	const handleOnChange = useCallback((event: CheckboxChangeEvent) => {
		onChange(event.target.checked);
	}, [ onChange ]);

	return (
		<div className='bulk-follow-checkbox'>
			<Checkbox
				checked={ checked }
				indeterminate={ indeterminate }
				onChange={ handleOnChange }>
				{ indeterminate ? COPY_SPECIFIC.MIXED : stateText }
			</Checkbox>
		</div>
	);
};
